export default __webpack_public_path__ + "static/media/5.306ab7c5.jpg";